import { useEffect, useState } from "react";

import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";
import { formatDate, LoadingDiv, SweetAlertShow } from "../master/Master";
import { enquiryReport } from "../../api/Enquiry";
import { courseList } from "../../api/Courses";
import { StaffList } from "../../api/Staff";
import { printImg } from "../master/Print";
import DashboardModal from "./components/DashboardModal";
import { formatToDate } from "../master/FormatToDateTime";
import { Link } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink";

export default function EnquiryReports() {
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [sessions, setSessions] = useState([]);
  const hasAccess = usePrivateLink();

  const [data, setReportData] = useState({});

  const [staffs, setStaffs] = useState([]);
  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);
  }, []);

  useEffect(() => {
    const activeSession = sessions?.find((s) => Number(s.status) === 1)?.id;
    setFilters((prev) => {
      if (prev.session_id || !activeSession) return prev;
      return {
        ...prev,
        session_id: activeSession,
      };
    });
  }, [sessions]);

  const [filters, setFilters] = useState({
    session_id: "",
    course_id: "",
    counselor_id: "",
    from_date: "",
    to_date: "",
  });

  useEffect(() => {
    getCourse();
    getStaffList();
  }, []);

  const getReport = async () => {
    try {
      setLoading(true);
      let addUrl = "";
      Object.keys(filters).forEach((key) => {
        const value = filters[key];
        if (value) {
          addUrl += `&${key}=${encodeURIComponent(value)}`;
        }
      });

      const res = await enquiryReport(addUrl);

      if (res?.data?.data) {
        setReportData(res.data?.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const getStaffList = async () => {
    setLoading(true);
    try {
      const response = await StaffList(`limit=all&status=1`);
      if (response.data.status) {
        setStaffs(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getCourse = async () => {
    setLoading(true);
    try {
      const response = await courseList();
      if (response.data.status) {
        setCourses(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const totalLeads = data?.summary?.total || 0;
  const totalAdmit = data?.summary?.admit || 0;

  const [allFilters, setAllFilters] = useState({});

  useEffect(() => {
    getReport();
  }, [filters]);

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="container-fluid p-4">
              <div className="row">
                {/* <Master /> */}

                <div className="col-12 ">
                  <div className="card p-3 mb-3 shadow-sm border-0">
                    <div className="d-flex justify-content-between align-items-center">
                      {/* LEFT SIDE */}
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            width: 45,
                            height: 45,
                            borderRadius: "12px",
                            background:
                              "linear-gradient(45deg,#185fa5,#4f8cff)",
                            color: "#fff",
                          }}
                        >
                          <i className="ri-bar-chart-2-line fs-5"></i>
                        </div>

                        <div>
                          <h5 className="m-0 fw-bold text-dark">
                            Enquiry Reports / Dashboard
                          </h5>
                          <small className="text-muted">
                            Track enquiries, performance & sources
                          </small>
                        </div>
                      </div>

                      <div className="d-flex align-items-center gap-2">
                        {/* ===== ACTIVE FILTERS ===== */}
                        <div className="d-flex flex-wrap gap-2 align-items-center">
                          {/* SESSION */}
                          {filters.session_id && (
                            <span className="badge rounded-pill bg-primary-subtle text-primary px-3 py-2">
                              Session:{" "}
                              {sessions.find((s) => s.id == filters.session_id)
                                ?.session || "All"}
                              <i
                                className="ri-close-line cursor-pointer"
                                onClick={() =>
                                  setFilters({ ...filters, session_id: "" })
                                }
                              ></i>
                            </span>
                          )}

                          {/* COURSE */}
                          {filters.course_id && (
                            <span className="badge rounded-pill bg-success-subtle text-success px-3 py-2">
                              Course:{" "}
                              {
                                courses.find((c) => c.id == filters.course_id)
                                  ?.title
                              }
                              <i
                                className="ri-close-line cursor-pointer"
                                onClick={() =>
                                  setFilters({ ...filters, course_id: "" })
                                }
                              ></i>
                            </span>
                          )}

                          {/* STAFF */}
                          {filters.counselor_id && (
                            <span className="badge rounded-pill bg-warning-subtle text-dark px-3 py-2">
                              Staff:{" "}
                              {
                                staffs.find((s) => s.id == filters.counselor_id)
                                  ?.name
                              }
                              <i
                                className="ri-close-line cursor-pointer"
                                onClick={() =>
                                  setFilters({ ...filters, counselor_id: "" })
                                }
                              ></i>
                            </span>
                          )}

                          {/* DATE RANGE */}
                          {filters.from_date && (
                            <span className="badge rounded-pill bg-info-subtle text-info px-3 py-2">
                              From: {filters.from_date}
                              <i
                                className="ri-close-line cursor-pointer"
                                onClick={() =>
                                  setFilters({ ...filters, from_date: "" })
                                }
                              ></i>
                            </span>
                          )}

                          {filters.to_date && (
                            <span className="badge rounded-pill bg-info-subtle text-info px-3 py-2">
                              To: {filters.to_date}
                              <i
                                className="ri-close-line cursor-pointer"
                                onClick={() =>
                                  setFilters({ ...filters, to_date: "" })
                                }
                              ></i>
                            </span>
                          )}
                          <button
                            className="badge rounded-pill bg-danger border-0 px-3 py-2"
                            onClick={() => {
                              const activeSession = sessions?.find(
                                (s) => Number(s.status) === 1,
                              )?.id;

                              setFilters({
                                session_id: activeSession || "",
                                course_id: "",
                                counselor_id: "",
                                from_date: "",
                                to_date: "",
                              });
                            }}
                          >
                            Clear All
                          </button>
                        </div>

                        {hasAccess("/enquiry/add") && (
                          <Link
                            to="/enquiry/add"
                            title="Add New Enquiry"
                            className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: 40, height: 40 }}
                          >
                            <i className="ri-add-line"></i>
                          </Link>
                        )}

                        <button
                          title="Open Filters"
                          className="btn btn-light border rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#filterCanvas"
                          style={{ width: 40, height: 40 }}
                        >
                          <i className="ri-filter-3-line text-primary"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div id="print" className="">
                    <div className="card-body">
                      {/* ================= KPI ================= */}
                      <div className="row g-3 mb-4 align-items-stretch">
                        <Card
                          title="Total Leads"
                          value={totalLeads}
                          color="#185fa5"
                          onClick={() =>
                            setAllFilters({ ...filters, table: "enquiry" })
                          }
                        />

                        <Card
                          title="Admissions"
                          value={totalAdmit}
                          color="#198754"
                          onClick={() =>
                            setAllFilters({
                              ...filters,
                              table: "enquiry",
                              status: "1",
                            })
                          }
                        />

                        <Card
                          title="Pending"
                          value={data?.summary?.pending || 0}
                          color="#fd7e14"
                          onClick={() =>
                            setAllFilters({
                              ...filters,
                              table: "enquiry",
                              status: "0",
                            })
                          }
                        />
                        <Card
                          title="Demo"
                          value={data?.summary?.demo || 0}
                          color="#0891b2"
                          onClick={() =>
                            setAllFilters({
                              ...filters,
                              table: "enquiry",
                              status: "4",
                            })
                          }
                        />
                        <Card
                          title="Visit"
                          value={data?.summary?.visit || 0}
                          color="#0891b2"
                          onClick={() =>
                            setAllFilters({
                              ...filters,
                              table: "enquiry",
                              status: "5",
                            })
                          }
                        />
                        {/* <Card
                          title="Followups"
                          value={data?.summary?.followups || 0}
                          color="#dc3545"
                          onClick={() =>
                            setAllFilters({ ...filters, table: "followups" })
                          }
                        /> */}
                        <Card
                          title="Rejected"
                          value={data?.summary?.rejected || 0}
                          color="#9333ea"
                          onClick={() =>
                            setAllFilters({
                              ...filters,
                              table: "enquiry",
                              status: "2",
                            })
                          }
                        />
                      </div>

                      <div className="card p-4 mt-4 mb-4 shadow-sm">
                        <div className="d-flex justify-content-between mb-3">
                          <div className="d-flex align-items-start mb-3">
                            <div
                              className="bg-primary me-2"
                              style={{
                                width: "4px",
                                height: "30px",
                                borderRadius: "2px",
                              }}
                            ></div>

                            <div>
                              <h5 className="mb-0 fw-bold">
                                Today / Activity Snapshot
                              </h5>
                            </div>
                          </div>
                        </div>

                        <div className="row ">
                          <div className="col-lg-3 col-md-4 col-sm-6">
                            <div
                              className="p-3 bg-white rounded-3 border h-100"
                              data-bs-toggle="modal"
                              data-bs-target="#MainModal"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                setAllFilters({
                                  ...filters,
                                  table: "enquiry",
                                  start_date: formatToDate(new Date()),
                                  end_date: formatToDate(new Date()),
                                })
                              }
                            >
                              <div
                                className="text-muted fw-bold"
                                style={{ fontSize: "12px" }}
                              >
                                NEW ENQUIRIES
                              </div>
                              <div className="fs-3 fw-bold text-primary">
                                {data?.today_summary?.total || 0}
                              </div>
                            </div>
                          </div>

                          {/* <div className="col-lg-2 col-md-4 col-sm-6">
                            <div className="p-3 bg-white rounded-3 border h-100">
                              <div
                                className="text-muted fw-bold"
                                style={{ fontSize: "12px" }}
                              >
                                DEMOS SCHEDULED
                              </div>
                              <div className="fs-3 fw-bold text-success">
                                {data?.today_summary?.demo || 0}
                              </div>
                            </div>
                          </div> */}

                          <div className="col-lg-3 col-md-4 col-sm-6">
                            <div className="p-3 bg-white rounded-3 border h-100">
                              <div
                                className="text-muted fw-bold"
                                style={{ fontSize: "12px", cursor: "pointer" }}
                                data-bs-toggle="modal"
                                data-bs-target="#MainModal"
                                onClick={() =>
                                  setAllFilters({
                                    ...filters,
                                    table: "enquiry",
                                    admission_date: formatToDate(new Date()),
                                  })
                                }
                              >
                                ADMISSIONS TODAY
                              </div>
                              <div className="fs-3 fw-bold text-purple">
                                {data?.today_summary?.admit || 0}
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-3 col-md-4 col-sm-6">
                            <div className="p-3 bg-white rounded-3 border h-100">
                              <div
                                className="text-muted fw-bold"
                                style={{ fontSize: "12px", cursor: "pointer" }}
                                data-bs-toggle="modal"
                                data-bs-target="#MainModal"
                                onClick={() =>
                                  setAllFilters({
                                    ...filters,
                                    table: "followups",
                                    followup_due_date: formatToDate(new Date()),
                                  })
                                }
                              >
                                FOLLOW-UPS DUE
                              </div>
                              <div className="fs-3 fw-bold text-danger">
                                {data?.today_summary?.dues_followups || 0}
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-3 col-md-4 col-sm-6">
                            <div className="p-3 bg-white rounded-3 border h-100">
                              <div
                                className="text-muted fw-bold"
                                style={{ fontSize: "12px", cursor: "pointer" }}
                                data-bs-toggle="modal"
                                data-bs-target="#MainModal"
                                onClick={() =>
                                  setAllFilters({
                                    ...filters,
                                    table: "followups",
                                    followup_date: formatToDate(new Date()),
                                  })
                                }
                              >
                                FOLLOW-UPS
                              </div>
                              <div className="fs-3 fw-bold text-success">
                                {data?.today_summary?.followups || 0}
                              </div>
                            </div>
                          </div>

                          {/* <div className="col-lg-2 col-md-4 col-sm-6">
                            <div className="p-3 bg-white rounded-3 border h-100">
                              <div
                                className="text-muted fw-bold"
                                style={{ fontSize: "12px" }}
                              >
                                VISITS
                              </div>
                              <div className="fs-3 fw-bold text-warning">
                                {data?.today_summary?.visit || 0}
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-2 col-md-4 col-sm-6">
                            <div className="p-3 bg-white rounded-3 border h-100">
                              <div
                                className="text-muted fw-bold"
                                style={{ fontSize: "12px" }}
                              >
                                REJECTED
                              </div>
                              <div className="fs-3 fw-bold text-info">
                                {data?.today_summary?.rejected || 0}
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </div>

                      {/* ================= TOP + SOURCE ================= */}
                      <div className="row g-3 ">
                        {/* Top Performer */}
                        <div className="col-md-6">
                          <div className="card p-4 shadow-sm h-100">
                            {/* HEADER */}
                            <div className="d-flex align-items-start mb-3">
                              <div
                                className="bg-primary me-2"
                                style={{
                                  width: "4px",
                                  height: "30px",
                                  borderRadius: "2px",
                                }}
                              ></div>

                              <h5 className="mb-0 fw-bold">Weekly Trend</h5>
                            </div>

                            {/* TABLE */}
                            <div className="table-responsive">
                              <table className="table table-sm">
                                <thead className="">
                                  <tr>
                                    <th className="text-muted">DATE</th>
                                    <th className="text-muted">ENQUIRIES</th>
                                    <th className="text-success">CONVERTED</th>
                                    <th className="text-danger">FOLLOWUPS</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {data?.last_days_summary?.map((d, i) => (
                                    <tr key={i}>
                                      <td className="text-primary">
                                        {formatDate(d?.date)}
                                      </td>

                                      <td className="text-muted">{d?.total}</td>

                                      <td className="text-success">
                                        {d?.admit}
                                      </td>
                                      <td className="text-danger">
                                        {d?.followups}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        {/* Source Table */}
                        <div className="col-md-6">
                          <div className="card p-4 shadow-sm h-100">
                            <div className="d-flex align-items-start mb-3">
                              {/* Left Blue Line */}
                              <div
                                className="bg-primary me-2"
                                style={{
                                  width: "4px",
                                  height: "30px",
                                  borderRadius: "2px",
                                }}
                              ></div>

                              {/* Text */}
                              <div>
                                <h5 className="mb-0 fw-bold">Source Report</h5>
                              </div>
                            </div>

                            <div className="table-responsive ">
                              <table className="table table-sm">
                                <thead>
                                  <tr>
                                    <th className="">Source</th>
                                    <th>Total</th>
                                    <th className="text-success">Admit</th>
                                    <th className="text-warning">Pending</th>
                                    <th className="text-danger">Rejected</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {data?.sources?.map((s, i) => (
                                    <tr key={i}>
                                      <td className="text-primary">
                                        <b>{s?.source || "Direct "}</b>
                                      </td>
                                      <td>{s?.total}</td>
                                      <td className="text-success">
                                        {s?.admit}
                                      </td>
                                      <td className="text-warning">
                                        {s?.pending}
                                      </td>
                                      <td className="text-danger">
                                        {s?.rejected}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card p-4 mt-4 shadow-sm">
                        {/* HEADER */}
                        <div className="d-flex align-items-start mb-3">
                          <div
                            className="bg-primary me-2"
                            style={{
                              width: "4px",
                              height: "30px",
                              borderRadius: "2px",
                            }}
                          ></div>

                          <h5 className="mb-0 fw-bold">Course-wise Summary</h5>
                        </div>

                        {/* TABLE */}
                        <div className="table-responsive">
                          <table className="table align-middle">
                            <thead className="">
                              <tr>
                                <th className="text-muted">COURSE</th>
                                <th className="text-muted">TOTAL ENQUIRIES</th>
                                <th className="text-success">CONVERTED</th>
                                <th className="text-info">Demo</th>
                                <th className="text-warning">PENDING</th>
                                <th className="text-primary">CONVERSION %</th>
                              </tr>
                            </thead>

                            <tbody>
                              {data?.courses?.map((c, i) => (
                                <tr key={i}>
                                  <td className="fw-semibold text-primary">
                                    {c?.course_name}
                                  </td>
                                  <td>{c?.total}</td>
                                  <td className="text-success fw-bold">
                                    {c?.admit}
                                  </td>
                                  <td className="text-info">{c?.demo}</td>
                                  <td className="text-warning">{c?.pending}</td>
                                  <td className="fw-bold text-primary">
                                    {c?.conversion}%
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {/* ================= STAFF TABLE ================= */}
                      <div className="card p-4 mt-4 shadow-sm">
                        <div className="d-flex justify-content-between mb-3">
                          <div className="d-flex align-items-start mb-3">
                            <div
                              className="bg-primary me-2"
                              style={{
                                width: "4px",
                                height: "45px",
                                borderRadius: "2px",
                              }}
                            ></div>

                            <div>
                              <h5 className="mb-0 fw-bold">
                                Counselors Performance Overview
                              </h5>
                              <small className="text-muted">
                                Click column headers to sort
                              </small>
                            </div>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="table align-middle data">
                            <thead className="">
                              <tr>
                                <th>Name</th>
                                <th>Leads</th>
                                <th className="text-success">Admit</th>
                                <th className="text-warning">Pending</th>
                                <th className="text-danger">Rejected</th>
                                <th>Followups</th>
                              </tr>
                            </thead>

                            <tbody>
                              {data?.counselors?.map((c, i) => (
                                <tr key={i}>
                                  <td className="fw-semibold">
                                    {c?.counselor_info?.name}
                                  </td>

                                  <td>{c.total}</td>

                                  <td className="text-success fw-bold">
                                    {c?.admit}
                                  </td>

                                  <td className="text-warning">{c?.pending}</td>

                                  <td className="text-danger">{c?.rejected}</td>

                                  <td>{c?.followups}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="offcanvas offcanvas-end" tabIndex="-1" id="filterCanvas">
        {/* HEADER */}
        <div className="offcanvas-header">
          <h5 className="offcanvas-title">Filters</h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>

        {/* BODY */}
        <div className="offcanvas-body">
          <div className="row g-3">
            {/* SESSION */}
            <div className="row g-3 pt-1">
              <div className="col-sm-12">
                <div className="form-floating form-floating-outline">
                  <select
                    className="form-select"
                    name="session"
                    value={filters?.session_id}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        session_id: e.target.value,
                      })
                    }
                  >
                    <option value="all">All</option>
                    {sessions?.map((session) => (
                      <option key={session?.id} value={session?.id}>
                        {session?.session} :{" "}
                        {session?.status === "1" ? "Active" : " Inactive"}
                      </option>
                    ))}
                  </select>

                  <label>Filter Session</label>
                </div>
              </div>

              <div className="col-sm-12">
                <div className="form-floating form-floating-outline">
                  <select
                    className="form-select form-control"
                    name="course_id"
                    value={filters?.course_id}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        course_id: e.target.value,
                      });
                    }}
                  >
                    <option value="">All</option>
                    {courses?.map((course, index) => (
                      <option key={index} value={course.id}>
                        {course.title}
                      </option>
                    ))}
                  </select>
                  <label className="ms-5">Course</label>
                </div>
              </div>
              <div className="col-sm-12">
                <div className="form-floating form-floating-outline">
                  <select
                    className="form-select form-control"
                    name="course_id"
                    value={filters.counselor_id}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        counselor_id: e.target.value,
                      })
                    }
                  >
                    <option value="">All</option>
                    {staffs?.length > 0 &&
                      staffs.map((c) => (
                        <option key={c?.id} value={c?.id}>
                          {c?.name}
                        </option>
                      ))}
                  </select>
                  <label className="ms-5">Staffs</label>
                </div>
              </div>

              {/* FROM DATE */}
              {/* START DATE */}
              <div className="col-sm-12">
                <div className="form-floating form-floating-outline">
                  <input
                    type="date"
                    className="form-control"
                    value={filters.from_date}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        from_date: e.target.value,
                      })
                    }
                    max={
                      filters.to_date || new Date().toISOString().split("T")[0]
                    }
                  />
                  <label>Start Date</label>
                </div>
              </div>

              {/* END DATE */}
              <div className="col-sm-12">
                <div className="form-floating form-floating-outline">
                  <input
                    type="date"
                    className="form-control"
                    value={filters.to_date}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        to_date: e.target.value,
                      })
                    }
                    min={filters.from_date}
                    max={new Date().toISOString().split("T")[0]}
                  />
                  <label>End Date</label>
                </div>
              </div>
            </div>

            {/* BUTTONS */}
            <div className="row g-2 mt-3">
              {/* APPLY */}
              <div className="col-6">
                <button
                  className="btn btn-primary w-100"
                  data-bs-dismiss="offcanvas"
                  onClick={getReport}
                >
                  Apply
                </button>
              </div>

              {/* RESET */}
              <div className="col-6">
                <button
                  className="btn btn-outline-danger w-100"
                  onClick={() => {
                    const activeSession = sessions?.find(
                      (s) => Number(s.status) === 1,
                    )?.id;

                    setFilters({
                      session_id: activeSession || "",
                      course_id: "",
                      counselor_id: "",
                      from_date: "",
                      to_date: "",
                    });
                  }}
                >
                  Reset
                </button>
              </div>

              {/* PRINT */}
              <div className="col-6">
                <button
                  className="btn btn-outline-dark w-100"
                  onClick={() => printImg("print", "Enquiry Report")}
                >
                  <i className="ri-printer-line me-1"></i> Print
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DashboardModal
        setLoading={setLoading}
        allFilter={allFilters}
        setAllFilter={setAllFilters}
      />
    </>
  );
}

// ================= CARD =================
function Card({ title, value, sub, color, onClick }) {
  return (
    <div
      className="col-lg-2 col-md-4 col-sm-6"
      data-bs-toggle="modal"
      data-bs-target="#MainModal"
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <div
        className=" h-100"
        style={{
          background: "#fff",
          border: "1px solid #e8e8e8",
          borderRadius: 10,
          padding: 16,
          borderTop: `3px solid ${color}`,
        }}
      >
        <div className="fw-bold" style={{ fontSize: 15, color: "#888" }}>
          {title}
        </div>
        <div style={{ fontSize: 24, fontWeight: 700 }}>{value}</div>
        {sub && <small style={{ color: "#aaa" }}>{sub}</small>}
      </div>
    </div>
  );
}
